import React, { useEffect, useState, useCallback } from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { arrowDownSvg } from '../../HelperMethods/constants';
import styles from './MultiSelectDropdownMenu.module.css';

const findSelectedOptions = (selected, option) => {
  if (Array.isArray(selected)) {
    return selected.find((val) => val === option.id);
  }
  return selected.id === option.id;
};

function useHandleSelection(selected) {
  const [selectedOption, setSelectedOptions] = useState([]);
  useEffect(() => {
    setSelectedOptions(selected);
  }, [selected]);
  const onOptionClicked = useCallback(
    (option) => {
      const clonedSelectedOption = [...selectedOption];
      const optionIndex = clonedSelectedOption.findIndex((selectedOpt) => selectedOpt === option);
      if (optionIndex > -1) {
        clonedSelectedOption.splice(optionIndex, 1);
      } else {
        clonedSelectedOption.push(option);
      }
      setSelectedOptions(clonedSelectedOption);
    },
    [setSelectedOptions, selectedOption]
  );
  return [selectedOption, onOptionClicked];
}

function MultiSelectDropdownMenu(props) {
  const { selected, options = [], onDropdownClose, label } = props;
  const [selectedOptions, onOptionClicked] = useHandleSelection(selected);
  return (
    <Dropdown
      text={label}
      className={styles.customMenu}
      multiple
      icon={
        <img
          className="icon dropdown"
          src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(arrowDownSvg('#a2a2a0'))}`}
        />
      }
      onClose={() => {
        onDropdownClose(selectedOptions);
      }}
    >
      <Dropdown.Menu
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{ maxHeight: '400px', width: '200px', overflowX: 'auto' }}
      >
        {options.map((option) => {
          return (
            <Dropdown.Item
              onClick={() => {
                onOptionClicked(option.id);
              }}
              key={option.id}
            >
              {option.name}
              <i
                className="fa fa-check"
                style={{
                  color: '#00CFBB',
                  float: 'right',
                  display: findSelectedOptions(selectedOptions, option) ? 'block' : 'none',
                }}
              />
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

MultiSelectDropdownMenu.propTypes = {
  onDropdownClose: PropTypes.func.isRequired,
  options: PropTypes.array,
  label: PropTypes.string.isRequired,
  selected: PropTypes.array,
};

export default MultiSelectDropdownMenu;
